// extracted by mini-css-extract-plugin
module.exports = {"heading":"JournalMain_heading__LgsFr","topPosts":"JournalMain_topPosts___fR5N","loadMore":"JournalMain_loadMore__J9Slz"};